import React, { useState,useEffect } from "react";
import { AutoComplete } from 'primereact/autocomplete';
import { convertLength } from "@mui/material/styles/cssUtils";


const SeleccionTipoDocumento = (props) => {
  console.log("sdadsadasdsa ".props)
  const [selectedAutoValue, setSelectedAutoValue] = useState(props.TIDPROPIETARIO);
  const [autoFilteredValue, setAutoFilteredValue] = useState([]);
  const [autoValue, setAutoValue] = useState(null);
  const [reload, setReload] = useState(true)
  const [edita, setEdita] = useState(props.editar)
  const APITABLASBASICAS = 'https://www.ancogenecop.com/APIANCO/controllers/selecciones.php?op='

  useEffect(() => {
    async function traerUsuarios() {
      const data = new FormData(); 
      await fetch(APITABLASBASICAS + 'SeleccionTipoDocumento', {
        method: 'POST',
        header: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        },
        body: data
      }).then((response) => response.json())
        .then((response) => {
            setAutoValue(response)
        })
        .catch((error) => {
          console.log(error);
        })
    }
        traerUsuarios()
  }, [reload]);


  const searchCountry = (event) => {
    setTimeout(() => {
        if (!event.query.trim().length) {
            setAutoFilteredValue([...autoValue]);
        }
        else {
            setAutoFilteredValue(autoValue.filter((a) => {
                return a.name.toUpperCase().startsWith(event.query.toUpperCase());
            }));
        }
    }, 250);
};



  const handleChange = (event) => {
    setSelectedAutoValue(event)
     if(props.handleplanta!=undefined){
        return props.handleplanta(event.code,props.opcion)
    }else{
        return props.handleretorna(event.code,props.opcion)
    }
  };



  return (
    <div className="p-error">
      {!edita ?
      <AutoComplete placeholder="Buscar" id="dd" dropdown value={selectedAutoValue}
      onChange={(e) => handleChange(e.value,props.opcion)}
      suggestions={autoFilteredValue} completeMethod={searchCountry} field="name" 
      />      
      :
      <AutoComplete  id="dd" dropdown value={selectedAutoValue}
      field="name" 
      />            
      }

    </div>
  );
};

export default SeleccionTipoDocumento;
